<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: false,
        },
        label: {
            type: String,
            required: false,
        },
        disable: {
            type: Boolean,
            required: false,
            default: false,
        },
        variant: {
            type: String,
            required: false,
            default: 'default',
        },

        /**
         * If click events should be ignored.
         *
         * You may want to handle click/toggle logic in a high-level component. This option allows you to turn off the
         * default click handler, and then you are free to do whatever you want.
         */
        externalClickHandler: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        noLabelContent() {
            return !this.label || this.label.length === 0;
        },
    },
    methods: {
        onChange(event) {
            this.$emit('input', event.target.checked);
        },
        onClick(event) {
            if (this.externalClickHandler) {
                this.$emit('checkbox-clicked');
                event.preventDefault();
            }
        },
    },
};
</script>

<template>
    <div
        class="checkbox"
        :class="{
            'checkbox--primary': variant === 'primary',
        }"
    >
        <input
            :id="$makeScopedValue('checkbox')"
            type="checkbox"
            :checked="value"
            :disabled="disable"
            @change="onChange"
        />
        <label :for="$makeScopedValue('checkbox')" :class="{ 'no-content': noLabelContent }" @click="onClick">
            {{ label }}
        </label>
    </div>
</template>

<style scoped lang="scss">
.checkbox {
    label {
        // This component relies on some global CSS styles to render the checkbox.
        // If we have some label text, then we want to use the global styles. But, if we don't have a label, we will
        // remove all the offsets, so that the checkbox can be embedded inside other components as well.
        &.no-content {
            padding: 0;
            display: block;

            &:before {
                display: block;
                margin: 0;
                position: initial;
            }

            &:after {
                margin: 0;
            }
        }
    }
}

.checkbox--primary {
    position: relative;

    label {
        color: var(--n-color-text);
    }

    & > label:before {
        content:'';
        -webkit-appearance: none;
        background-color: transparent;
        border: 2px solid var(--n-color-border);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
        padding: 10px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 5px;
    }

    & > input:checked + label:before {
        background-color: var(--n-color-accent);
        border-color: var(--n-color-accent);
    }

    & > input:checked + label:after {
        content: '';
        display: block;
        position: absolute;
        top: 5px;
        left: 15px;
        width: 5px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }

}
</style>
